import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;

export const Content = styled.div`
    width: calc(100% - 40px);
    padding: 20px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 10px;
    max-width: 550px;
`;

export const Title = styled.h1`
    width: 100%;
    font-size: 20px;
    margin: 0;
    margin-bottom: 30px;
`;

export const Message = styled.p`
    font-weight: 100;
    width: 100%;
    font-size: 16px;
    margin-bottom: 30px;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
`;